// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__260jR","inputWrap":"styles_inputWrap__13cQ8","input":"styles_input__1vn1t"};